import type { ModelClientFieldValue } from '@app/api/Client';

import type { FC } from 'react';

import './UserAdditionalFields.scss';

interface UserAdditionalFieldsProps {
  items: ModelClientFieldValue[];
}

/**
 * Важные дополнительные поля клиента в карточке лида.
 * Контракт GetLeadCard.ClientFields — ModelClientFieldValue: FieldName —
 * название поля, Value — значение, IsImportant — признак важности.
 * Неважные поля видны на странице редактирования клиента.
 */
export const UserAdditionalFields: FC<UserAdditionalFieldsProps> = ({
  items,
}) => {
  const visibleItems = items.filter(
    ({ IsImportant, Value }) => IsImportant && Boolean(Value?.trim())
  );

  if (!visibleItems.length) return null;

  return (
    <div className="UserAdditionalFields">
      {visibleItems.map(({ FieldId, FieldName, Value }) => (
        <div key={FieldId} className="UserAdditionalFields__item">
          <span className="UserAdditionalFields__label">{FieldName}: </span>
          <span className="UserAdditionalFields__value">{Value}</span>
        </div>
      ))}
    </div>
  );
};
